import React from "react";
import { Box, Grid } from "@mui/material";
import _ from "lodash";
import ProcessParticipantOrganizationForm from "./ProcessParticipantOrganizationForm";
import { scrollToAnchor } from "../../../../theme/commonStyles";
import { ProductUnion } from "../../../../types/ProductUnion";
import { CaseOrganization } from "../../../../types/CaseOrganization";

type ProcessParticipantsOrganizationsFormProps = {
  product: ProductUnion;
  refreshPage: Function;
};
const ProcessParticipantsOrganizationsForm = ({ product, refreshPage }: ProcessParticipantsOrganizationsFormProps) => {
  return (
    <Grid container>
      {_.map(_.sortBy(product.processParticipantsOrganizations, "id"), (participant: CaseOrganization) => (
        <Grid key={participant.id} size={12}>
          <Box sx={scrollToAnchor} id={"processParticipantOrganization" + participant.id} />
          <ProcessParticipantOrganizationForm product={product} participant={participant.organization} refreshPage={refreshPage} />
        </Grid>
      ))}
    </Grid>
  );
};
export default ProcessParticipantsOrganizationsForm;
